@if(shouldShowSummary){
<div class="cf_overview_summary">
	<div class="cf_overview_summary-container c_left">
		<div
			class="cf_overview_summary-container-tile companies"
			(click)="handleClick(DrilldownTypes.Count)"
		>
			<div class="cf_overview_summary-container-tile-content companies">
				<div
					class="cf_overview_summary-container-tile-content-count companies-count"
					(mouseenter)="showTotalTooltip()"
					(mouseleave)="hideTotalTooltip()"
				>
					<div>
						{{
							currentCompanyCountDisplay
						}}@if(!showingAllCompanies){<span
							class="cf_overview_summary-container-tile-content-count-denominator"
							>/{{ totalCompaniesCountDisplay }}</span
						>}
					</div>
					@if(isShowingTotalTooltip){
					<div
						class="cf_overview_summary-container-tile-content-count-tooltip"
					>
						{{ totalToolipText }}
					</div>
					}
				</div>
				<div class="cf_overview_summary-container-tile-content-label">
					{{ titleLabel }}
				</div>
			</div>
		</div>
	</div>
	@if(featureSwitches.enableSectors) {
	<div class="cf_overview_summary-container c_middle">
		@for(sector of _deploymentContext.sectorNames; track sector) {
		<div
			class="cf_overview_summary-container-tile"
			(click)="handleClick(DrilldownTypes.Sector, sector)"
		>
			<div class="cf_overview_summary-container-tile-content">
				<div class="cf_overview_summary-container-tile-content-count">
					{{ summary.companyCountBySector(sector) }}
				</div>
				<div class="cf_overview_summary-container-tile-content-label">
					{{ LocWithPrefix(sector, LocPrefix.SectorShortName) }}
				</div>
			</div>
		</div>
		} @if(shouldShowCrossSector){
		<div class="cf_overview_summary-container-tile-separator left"></div>
		<div
			class="cf_overview_summary-container-tile cross-sector"
			(click)="handleClick(DrilldownTypes.CrossSector)"
		>
			<div
				class="cf_overview_summary-container-tile-content cross-sector"
			>
				<div
					class="cf_overview_summary-container-tile-content-count cross-sector"
				>
					{{ summary.numberOfCrossSectorCompanies }}
				</div>
				<div class="cf_overview_summary-container-tile-content-label">
					{{ Loc(LocalizedTextIds.SummaryCrossSector) }}
				</div>
			</div>
		</div>
		} @if(shouldShowRightSeparator){
		<div class="cf_overview_summary-container-tile-separator right"></div>
		}
	</div>
	} @if(shouldShowRightContainer){
	<div class="cf_overview_summary-container c_right">
		@if(shouldShowNewCompanyCount) {
		<div
			class="cf_overview_summary-container-tile"
			(click)="handleClick(DrilldownTypes.New)"
		>
			<div class="cf_overview_summary-container-tile-content left">
				<div class="cf_overview_summary-container-tile-content-count">
					{{ summary.numberOfNewCompanies }}
				</div>
				<div class="cf_overview_summary-container-tile-content-label">
					{{ Loc(LocalizedTextIds.New) }}
				</div>
			</div>
		</div>
		} @if(shouldShowShowStatusCount) {
		<div
			class="cf_overview_summary-container-tile"
			(mouseenter)="showTileTooltip()"
			(mouseleave)="hideTileTooltip()"
			(click)="handleClick(DrilldownTypes.Status)"
		>
			<div class="cf_overview_summary-container-tile-content">
				<div
					class="cf_overview_summary-container-tile-content-count special"
				>
					{{ numberOfResidentsForStatusTile }}
					@if(isShowingTileTooltip){
					<div
						class="cf_overview_summary-container-tile-content-count-tooltip tile"
					>
						{{ tileTooltip }}
					</div>
					}
				</div>
				<div
					class="cf_overview_summary-container-tile-content-label status-label"
				>
					{{ tileLabel }}
				</div>
			</div>
		</div>
		} @if(shouldShowQfcCount) {
		<div
			class="cf_overview_summary-container-tile"
			(click)="handleClick(DrilldownTypes.QfcWinner)"
		>
			<div class="cf_overview_summary-container-tile-content">
				<div
					class="cf_overview_summary-container-tile-content-count special"
				>
					{{ summary.numberOfQfcWinners }}
				</div>
				<div class="cf_overview_summary-container-tile-content-label">
					{{ Loc(LocalizedTextIds.QFCAwardees) }}
				</div>
			</div>
		</div>
		} @if(shouldShowBlueKnightCount) {
		<div
			class="cf_overview_summary-container-tile"
			(click)="handleClick(DrilldownTypes.BlueKnight)"
		>
			<div class="cf_overview_summary-container-tile-content">
				<div
					class="cf_overview_summary-container-tile-content-count special"
				>
					{{ summary.numberOfBlueKnights }}
				</div>
				<div class="cf_overview_summary-container-tile-content-label">
					{{ Loc(LocalizedTextIds.BlueKnight) }}
				</div>
			</div>
		</div>
		}
	</div>
	}
</div>
}
